// extracted by mini-css-extract-plugin
export default {"button":"_1GzG3","downloadIcon":"_1JJR8"};